import { Flex } from '@revenuemarket/cds';
import { GrayColors } from '@revenuemarket/design';

export const Pannel = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex
      direction="column"
      gap={16}
      style={{
        backgroundColor: GrayColors.gray50,
        borderRadius: 12,
        padding: 16,
      }}
    >
      {children}
    </Flex>
  );
};
